import React from 'react';
import { CornerStyle, ButtonStyle } from '@mnz/builder';
import { px2rem } from '../core';

export const labelCss = () => ({
    fontWeight: 600,
});

export const getBackgroundCSS = (background: { color: string; image: string }) => {
    const obj: React.CSSProperties = {};
    if (background.image) {
        obj.backgroundImage = `url(${background.image})`;
        obj.backgroundRepeat = 'repeat';
    }
    if (!background.image && background.color) {
        obj.background = background.color;
    }
    return obj;
};

export const getBorderCSS = ({
    color,
    buttonStyle,
    corner,
    maxBorderRadius,
    isIcon,
}: {
    buttonStyle?: ButtonStyle;
    color?: string;
    corner?: CornerStyle;
    maxBorderRadius?: number;
    isIcon?: boolean;
}) => {
    const obj: React.CSSProperties = { ...corner };
    if (maxBorderRadius && maxBorderRadius < +corner?.borderRadius?.split('em')[0]) {
        obj['borderRadius'] = `${maxBorderRadius}em`;
    }

    if (isIcon) {
        const iconBorder = +corner?.borderRadius?.split('em')[0] / 2;
        if (!!iconBorder) {
            obj['borderRadius'] = `${iconBorder}em`;
        }
    }

    if (!buttonStyle || buttonStyle === 'outline') {
        if (color) {
            obj.borderWidth = '1px';
            obj.borderColor = color;
        }
    }
    if (buttonStyle === 'solid') {
        if (color) {
            obj.background = color;
        }
    }
    return obj;
};

export const cardCss = () => ({
    display: 'flex',
});
export const cardMediaCss = () => ({
    flexShrink: 0,
});
export const cardContentCss = () => ({
    flexGrow: 1,
});

export const descriptionCss = (theme) => ({
    color: theme.palette.primary70,
    fontSize: px2rem(14),
});

export const boxCss = (theme) => ({
    border: `1px solid ${theme.palette.primary40}`,
    borderRadius: px2rem(8),
    padding: px2rem(16),
});

export const hoverAnimationCss = ({
    content,
    active = true,
    hoverCss,
    css,
    contentPosition = 'TOP',
}: {
    content?: string;
    active?: boolean;
    hoverCss?: any;
    css?: any;
    contentPosition?: 'TOP' | 'BOT';
}) => {
    if (!active) return {};
    return {
        transition: '0.5s',
        position: 'relative',
        borderWidth: '2px',
        borderColor: 'transparent',
        ...css,
        '::before': {
            content,
            position: 'absolute',
            color: '#fff',
            backgroundColor: (theme) => theme.palette.success.main,
            top: '0px',
            left: '-2px',
            transform: contentPosition == 'TOP' ? 'translateY(-100%)' : 'translateY(0)',
            padding: '4px',
            fontWeight: '700',
            fontFamily: (theme) => theme.typography.fontFamily,
            borderTopLeftRadius: '4px',
            borderTopRightRadius: '4px',
            fontSize: '10px',
            lineHeight: '12px',
            opacity: 0,
            transition: '0.5s',
        },
        ':hover': {
            ...hoverCss,
            borderColor: (theme) => theme.palette.success.main,
            '::before': {
                opacity: 1,
            },
        },
    };
};
